// First Created - 27 Apr 2026
// Author - Atul Pandey

import {
    createSelector,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import { apiSlice } from '@/app/api/apiSlice'

const accountsAdapter = createEntityAdapter({})

const initialState = accountsAdapter.getInitialState()

export const accountsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getAccounts: builder.query({
            query: ({ organizationBUId = "" } = {}) => ({
            // query: ({ ownerOrgId, organizationBUId = "" }) => ({
                url: '/accounts/getAccounts',
                params: {
                    ...(organizationBUId ? { organizationBUId } : {}),
                },
                // params: {
                //     ownerOrgId,
                //     ...(organizationBUId ? { organizationBUId } : {}),
                // },
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                }
            }),
            transformResponse: responseData => {
                const loadedAccounts = responseData.map(account => {
                    account.id = account._id
                    return account
                })
                return accountsAdapter.setAll(initialState, loadedAccounts)
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'Account', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'Account', id }))
                    ]
                } else {
                    return [{ type: 'Account', id: 'LIST' }]
                }
            },
        }),

        createNewAccount: builder.mutation({
            query: initialAccount => ({
                url: '/accounts/createNewAccount',
                method: 'POST',
                body: { ...initialAccount }
            }),
            invalidatesTags: [
                { type: 'Account', id: 'LIST' }
            ]
        }),

        updateAccount: builder.mutation({
            query: initialAccount => ({
                url: '/accounts/updateAccount',
                method: 'PATCH',
                body: { ...initialAccount }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Account', id: arg.id },
                { type: 'Account', id: 'LIST' }
            ],
        }),

        deleteAccount: builder.mutation({
            query: ({ id, deleteMode = "soft" }) => ({
                url: '/accounts/deleteAccount',
                method: 'DELETE',
                body: { id, deleteMode }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Account', id: arg.id },
                { type: 'Account', id: 'LIST' }
            ]
        }),
    }),
})

export const {
    useGetAccountsQuery,
    useCreateNewAccountMutation,
    useUpdateAccountMutation,
    useDeleteAccountMutation,
} = accountsApiSlice

export const selectAccountResult = accountsApiSlice.endpoints.getAccounts.select()

const selectAccountsData = createSelector(
    selectAccountResult,
    accountResult => accountResult.data
)

export const {
    selectAll: selectAllAccounts,
    selectById: selectAccountById,
    selectIds: selectAccountIds,
} = accountsAdapter.getSelectors(state => selectAccountsData(state) ?? initialState)